<template>
    <v-menu v-model="notificationsMenuOpen" offset-y left>
        <template v-slot:activator="{ on: menuOn }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltipOn }">
                    <v-btn
                        class="px-3"
                        min-width="0"
                        v-on="{ ...menuOn, ...tooltipOn }"
                        :input-value="notificationsMenuOpen"
                        active-class="primary--text"
                        e2e-toolbar-notifications>
                        <v-badge v-if="hasNotifications" :content="notificationCount" color="primary" overlap>
                            <v-icon small>mdi-bell-outline</v-icon>
                        </v-badge>
                        <v-icon small v-else>mdi-bell-outline</v-icon>
                    </v-btn>
                </template>
                <span>Notifications</span>
            </v-tooltip>
        </template>
        <v-list nav dense min-width="200">
            <v-list-item @click="openTasks()">
                <v-list-item-title class="subtitle-2 secondary--text">Tasks ({{ runningTasksError ? `error` : `${runningTasks} running` }})</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openRequests()">
                <v-list-item-title class="subtitle-2 secondary--text">Requests ({{ validRequests.length }} pending)</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'UserNotificationsMenu',
    data() {
        return {
            notificationsMenuOpen: false
        }
    },
    computed: {
        ...mapState('userStore', ['runningTasks']),
        ...mapGetters('userStore', ['validRequests']),
        runningTasksError() {
            return this.runningTasks instanceof Error
        },
        notificationCount() {
            return this.validRequests.length + (this.runningTasksError ? 0 : this.runningTasks)
        },
        hasNotifications() {
            return (!this.runningTasksError && this.runningTasks > 0) || this.validRequests.length
        }
    },
    methods: {
        openTasks() {
            this.$router.push({ name: 'user-tasks' })
        },
        openRequests() {
            this.$router.push({ name: 'user-requests' })
        }
    }
}
</script>
